<template>
  <div class="settings">
    <h2>Settings</h2>
    <div class="settings-wrapper">
      <div class="">
        <strong>Player name</strong>
        <input type="text" v-model="playerName" placeholder="playerName"></input>
      </div>
      <div class="tile-colors">
        <strong>Tile color</strong>
        <div class="tiles">
          <Tile v-for="tile in availableTileColors" :disabled="tile === 'secret'" @click.native="selectTileColor(tile)" v-bind:tile="{alive: true, health: 8}" :color="tile" :class="{'selected': tile === selectedTileColor}" v-bind:key="tile"></Tile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tile from '@/components/Tile';
import storage from 'local-storage-fallback';

export default {
  name: 'settings',
  components: { Tile },
  data() {
    return {
      selectedTileColor: 're',
      playerName: '',
      availableTileColors: ['re'],
      pointsNeededForUnlock: 500,
    };
  },
  methods: {
    save() {
      storage.setItem('playerName', this.playerName);
      storage.setItem('tileColor', this.selectedTileColor);
    },
    selectTileColor(color) {
      if (color !== 'secret') {
        this.selectedTileColor = color;
        storage.setItem('tileColor', color);
      }
    },
  },
  mounted() {
    const highscore = (storage.getItem('highscore') || 0);

    this.availableTileColors.push(highscore > (1 * this.pointsNeededForUnlock) ? 'pi' : 'secret');
    this.availableTileColors.push(highscore > (2 * this.pointsNeededForUnlock) ? 'pu' : 'secret');
    this.availableTileColors.push(highscore > (3 * this.pointsNeededForUnlock) ? 'depu' : 'secret');
    this.availableTileColors.push(highscore > (4 * this.pointsNeededForUnlock) ? 'in' : 'secret');
    this.availableTileColors.push(highscore > (5 * this.pointsNeededForUnlock) ? 'bl' : 'secret');
    this.availableTileColors.push(highscore > (6 * this.pointsNeededForUnlock) ? 'libl' : 'secret');
    this.availableTileColors.push(highscore > (7 * this.pointsNeededForUnlock) ? 'cy' : 'secret');
    this.availableTileColors.push(highscore > (8 * this.pointsNeededForUnlock) ? 'te' : 'secret');
    this.availableTileColors.push(highscore > (9 * this.pointsNeededForUnlock) ? 'gr' : 'secret');
    this.availableTileColors.push(highscore > (10 * this.pointsNeededForUnlock) ? 'ligr' : 'secret');
    this.availableTileColors.push(highscore > (11 * this.pointsNeededForUnlock) ? 'li' : 'secret');
    this.availableTileColors.push(highscore > (12 * this.pointsNeededForUnlock) ? 'ye' : 'secret');
    this.availableTileColors.push(highscore > (13 * this.pointsNeededForUnlock) ? 'am' : 'secret');
    this.availableTileColors.push(highscore > (14 * this.pointsNeededForUnlock) ? 'or' : 'secret');
    this.availableTileColors.push(highscore > (15 * this.pointsNeededForUnlock) ? 'deor' : 'secret');
    this.availableTileColors.push(highscore > (16 * this.pointsNeededForUnlock) ? 'br' : 'secret');
    this.availableTileColors.push(highscore > (17 * this.pointsNeededForUnlock) ? 'gra' : 'secret');
    this.availableTileColors.push(highscore > (18 * this.pointsNeededForUnlock) ? 'blgr' : 'secret');
    this.availableTileColors.push(highscore > (20 * this.pointsNeededForUnlock) ? 'wh' : 'secret');

    this.playerName = storage.getItem('playerName');
    this.availableTileColors.push((highscore > (21 * this.pointsNeededForUnlock) || this.playerName.indexOf('Jack renlund') > -1) ? 'mc' : 'secret');


    this.selectedTileColor = (storage.getItem('tileColor') || 're');
  },
  watch: {
    playerName() {
      storage.setItem('playerName', this.playerName);
    },
  },
};
</script>

<style lang="less">
.settings {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  height: 100%;

  .settings-wrapper {
    flex-grow: 2;
  }

  strong {
    font-size: 1.3rem;
  }




  .footer {
    padding-top: 1rem;
  }

  .tiles {
    display: flex;
    width: 100%;
    height: 4.5rem;
    flex-wrap: wrap;

    .tile {
      height: 100%;
      width: 100%/7;
      &.selected {

        .inner {
          // border: 3px solid #fff;
          &::after {
            content: "\f00c";
            font-family: "Font Awesome 5 Free";
            position: absolute;
            top: -2.5px;
            right: -2.5px;
            border-radius: 50%;
            background: #fff;
            color: #333;
            line-height: 1;
            padding: .1rem .1rem;
            transition: all ease .3s;
          }
        }
      }
    }
  }

  button {
    margin: 0;
  }


  strong {
    display: block;
    margin: 2rem 0 .25rem;
  }

  input {
    border-radius: .25rem;
    width: 100%;
    display: block;
    padding: 1.3rem;
    border: none;
    margin: .75rem 0;
    font-family: 'Raleway', 'Open Sans', sans-serif;
    font-weight: 100;
    font-size: 1.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// Settings.vue?15d076a2